import React, { useState, useEffect } from 'react'
import { TableBodyProps } from './types'
import { MAX_LATLNG, URL_KEY } from './constants'
import { fetchApi, formatAddress, getCity, getState, transformKeys } from './utils'

const TableBody = ({
    events,
    fields,
    integration,
    handleLoading,
}: TableBodyProps): JSX.Element => {
    const [addresses, setAddresses] = useState({})
    const [addressMap, setAddressMap] = useState({})
  
    useEffect(() => {
        const params = new URLSearchParams()
        const remainder = events.length % MAX_LATLNG > 0 ? 1 : 0
        const integerDivision = Math.trunc(events.length / MAX_LATLNG)
        let returnedAddresses = {}
        let lastPosition = 0

        const outer = async () => {
            if (events) {
                for (let i = 0; i < integerDivision + remainder; i++) {
                    params.delete(URL_KEY)
                    let nextHop = lastPosition + MAX_LATLNG - 1
                    if (nextHop > events.length) nextHop = events.length - 1
                    for (let j = lastPosition; j <= nextHop; j++) {
                        const { __lat, __lng } = events[j]
                        params.append(URL_KEY, `${__lat},${__lng}`)
                    }
                    lastPosition = nextHop + 1
                    if (params.toString().length > 0) {
                        const run = async () =>
                            await fetchApi(
                                'GET',
                                `/services/plugin-extension-google/${integration}/reverse-geocode?${params.toString()}`
                            )
                                .then(response => {
                                    const transformed = transformKeys(i, response.data)
                                    returnedAddresses = { ...returnedAddresses, ...transformed }
                                })
                                .then(() => {
                                    if (i + 1 === integerDivision + remainder) handleLoading(false)
                                })
                        await run()
                    }
                }
                setAddresses(returnedAddresses)
            }
        }
        outer()
    }, [events])

    useEffect(() => {
        if (addresses && events) {
            const addressMapAux = {}
            events.forEach(({ __lat, __lng }, index) => {
                const address = addresses[index]

                if (address != null && address.geocodingResult != null) {
                    addressMapAux[`${__lat},${__lng}`] = {
                        address: formatAddress(address.geocodingResult.addressComponents),
                        city: getCity(address.geocodingResult.addressComponents),
                        state: getState(address.geocodingResult.addressComponents)
                    }
                } else {
                    addressMapAux[`${__lat},${__lng}`] = { address: 'N/A', city: 'N/A', state: 'N/A' }
                }
            })
            setAddressMap(previous => {
                return { ...previous, ...addressMapAux }
            })
        }
    }, [addresses])

    return (
        <tbody>
            {events.map((event, index) => {
                return (
                    <tr>
                        {fields.map(field => {
                            return (
                                <td className={index == 0 ? 'first-column' : ''}>
                                    <div className="widget-table-truncate">
                                        <div
                                            className={`widget-table-truncated ${field}`}
                                            dangerouslySetInnerHTML={{ __html: event?.[field] }}
                                        />
                                    </div>
                                </td>
                            )
                        })}
                        <td className={index == 0 ? 'first-column' : ''}>
                            <div className="widget-table-truncate">
                                <div className={`widget-table-truncated `}>
                                    {addressMap[`${event['__lat']},${event['__lng']}`]?.address || 'N/A'}
                                </div>
                            </div>
                        </td>
                        <td className={index == 0 ? 'first-column' : ''}>
                            <div className="widget-table-truncate">
                                <div className={`widget-table-truncated `}>
                                    {addressMap[`${event['__lat']},${event['__lng']}`]?.city || 'N/A'}
                                </div>
                            </div>
                        </td>
                        <td className={index == 0 ? 'first-column' : ''}>
                            <div className="widget-table-truncate">
                                <div className={`widget-table-truncated `}>
                                    {addressMap[`${event['__lat']},${event['__lng']}`]?.state || 'N/A'}
                                </div>
                            </div>
                        </td>
                    </tr>
                )
            })}
        </tbody>
    )
}

export default TableBody
